import { Box, Grid, Text, Title } from "@mantine/core";
import { IconCircle, IconCircleFilled } from "@tabler/icons-react";

import { CallToAction } from "@/components/CallToAction";
import { ShippingQuote } from "@/types/api/shipment";
import styles from "./styles.module.scss";
import { toBRL } from "@/utils/formatters/formatCurrency";

interface ShipmentQuotesProps {
  handleFindShipmentQuotes: () => void;
  shipmentQuotes: ShippingQuote[];
  selectedShipmentQuote: ShippingQuote | null;
  setSelectedShipmentQuote: (quote: ShippingQuote) => void;
  handleAcceptShipmentQuote: () => void;
}

export function ShipmentQuotes({
  handleFindShipmentQuotes,
  shipmentQuotes,
  selectedShipmentQuote,
  setSelectedShipmentQuote,
  handleAcceptShipmentQuote,
}: ShipmentQuotesProps) {
  return (
    <Grid mt={30}>
      <Grid.Col span={{ md: 12 }}>
        {shipmentQuotes.length <= 0 ? (
          <CallToAction
            w="100%"
            onClick={handleFindShipmentQuotes}
            type="button"
          >
            Calcular Frete
          </CallToAction>
        ) : (
          <Title>Selecione um frete:</Title>
        )}
      </Grid.Col>

      {shipmentQuotes.map((quote, i) => (
        <Grid.Col span={{ md: 12 }} key={i}>
          <Box
            className={styles.shippingQuoteContainer}
            onClick={() => setSelectedShipmentQuote(quote)}
          >
            {selectedShipmentQuote?.shippingCode === quote.shippingCode ? (
              <IconCircleFilled color="#c8a977" />
            ) : (
              <IconCircle color="#c8a977" />
            )}

            <Box className={styles.shippingQuoteInfo}>
              <Text>{quote.carrier}</Text>
              <Text>
                {toBRL(quote.shippingPrice)} -{" "}
                {`${quote.deliveryTime} ${quote.deliveryTime === 1 ? "dia útil" : "dias úteis"}`}
              </Text>
            </Box>
          </Box>
        </Grid.Col>
      ))}

      <Grid.Col span={{ md: 12 }}>
        {selectedShipmentQuote !== null && (
          <CallToAction
            w="100%"
            type="button"
            onClick={handleAcceptShipmentQuote}
          >
            Selecionar Frete
          </CallToAction>
        )}
      </Grid.Col>
    </Grid>
  );
}
